import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from "react-toastify";

const PrivateRoute = ({ children, adminOnly = false }) => {
    const { isAuthenticated, user, isInitialAuthCheck } = useAuth();
    const location = useLocation();

    useEffect(() => {
        // Éviter les notifications lors du chargement initial
        if (!isInitialAuthCheck && !isAuthenticated) {
          /*  toast.warning("Vous devez vous connecter pour accéder à cette page.", {
                toastId: 'login-required'
            });*/
        }
    }, [isAuthenticated, isInitialAuthCheck]);

    // Bloquer la redirection pendant le chargement initial
    if (isInitialAuthCheck) {
        return null;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    if (adminOnly && !user?.roleNames?.includes('ADMIN')) {
        toast.error("Accès refusé : droits insuffisants.", {
            toastId: 'insufficient-rights'
        });
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PrivateRoute;